<template>
  <card class="card">
    <div class="card-container margin-vertical-ml">
      <img src="/images/celebration-hands.png">
      <div class="headline ri-bold-title margin-top-sm">
        <span> היי {{ firstName }}, איזה כיף </span>
        <span>שהצטרפת לאתגר!</span>
      </div>
      <div class="description ri-bodymargin-top-xs">
        האתגר יתחיל
        <span class="ri-bold-body">ביום {{ day }}׳ {{ shortDate }}</span>
        ובמהלכו נשלח תזכורות יומיות בוואטסאפ.
      </div>
    </div>
  </card>
</template>

<script lang="ts" setup>

import { computed } from 'vue';
import { getHebrewDayOfWeek, getShortDateWithoutYear } from '../../utils/date';

interface Props {
  firstName: string;
  startDate: Date;
}

const props = defineProps<Props>();
const day = computed(() => getHebrewDayOfWeek(props.startDate));
const shortDate = computed(() => getShortDateWithoutYear(props.startDate));
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
.card {
  background-color: $riseup_white;
  color: $riseup_black;

  .card-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .headline {
      white-space: pre-wrap;
      text-align: center;
      display: flex;
      flex-direction: column;
    }

    .description {
      text-align: center;
    }
  }
}
</style>
